<template>
  <!-- <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in" appear>
      <component :is="Component" :key="$route.path"></component>
    </transition>

  </router-view> -->
  <loading-spinner v-if="showLoading" />
  <teleport to="body">
    <modal-component
      v-if="modalState.visible"
      v-bind="modalState.props"
      :component="modalState.component"
      :componentProps="modalState.componentProps"
      :componentEvents="modalState.componentEvents"
      :actions="modalState.actions"/>
  </teleport>
  <router-view />

  <div
    class="style-offline-message d-flex align-items-center justify-content-center"
    v-if="!onLine"
  >
    No Internet Connection
  </div>
</template>

<script>
import LoadingSpinner from "./components/LoadingSpinner.vue";
import ModalComponent from "@/components/ModalComponent";
import { mapGetters, mapMutations } from "vuex";
import { modalState } from "@/store/modal";

export default {
  name: "App",
  components: {
    LoadingSpinner,
    ModalComponent
  },
  data() {
    return {
      onLine: navigator.onLine,
    };
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    },
    showPWAInstallationMessage() {
      // Check if IOS and PWA not installed
      if (
        (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
          (navigator.platform === "MacIntel" &&
            navigator.maxTouchPoints > 1)) &&
        !matchMedia("(display-mode: standalone)").matches &&
        window.matchMedia("(max-width: 1024px)").matches
      ) {
        this.showPWAInstallationToast(true);
      }

      setTimeout(() => {
        this.showPWAInstallationToast(false);
      }, 2000);
    },
    goToHomePage() {
      this.$router.push("/home");
    },
    handleForceBranchSelectionModal() {
      window.forceBranchSelectionModal.hide();
    },
    ...mapMutations(["showPWAInstallationToast"]),
  },
  computed: {
    modalState() {
      return modalState;
    },
    ...mapGetters(["showLoading"]),
  },
  created() {
    this.showPWAInstallationMessage();
    const apiUrl = `${process.env.VUE_APP_BASE_URL}/portals/customer/setting`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        // docs (guide): https://web.dev/learn/pwa/web-app-manifest/
        // dynamic set manifest.js with Customer Web App Setting
        let manifest = {
          name: data.appName ? data.appName : "WESS Consumer Web App",
          short_name: data.appName ? data.appName : "WESS CWA",
          description: data.appDescription ? data.appDescription : "",
          start_url: window.location.origin + "/home",
          scope: window.location.origin + "/home",
          display: "standalone",
        };
        if (data.appIcon) { // for Firefox
          manifest.icons = [
            {
              src: data.appIcon,
              size: "any"
            }
          ]
        }
        const stringManifest = JSON.stringify(manifest);
        const blob = new Blob([stringManifest], { type: "application/json" });
        const manifestURL = URL.createObjectURL(blob);
        document
          .getElementById("dynamic-manifest")
          .setAttribute("href", manifestURL);

        // dynamic set favicon with Customer Web App Setting
        if (data.favicon) {
          document.querySelectorAll("link[rel~='icon']").forEach((icon) => {
              icon.setAttribute("href", data.favicon);
          });
        }

        // dynamic set apple IOS setting with Customer Web App Setting
        document
          .getElementById("dynamic-apple-web-app-content")
          .setAttribute("content", data.appName);

        // dynamic set app icon(PWA) with Customer Web App Setting
        if (data.appIcon) {
          document
            .querySelector("link[rel~='android-touch-icon']")
            .setAttribute("href", data.appIcon);

          document
            .getElementById("dynamic-apple-touch-icon")
            .setAttribute("href", data.appIcon);
        }

        // dynamic set page title with Customer Web App Setting
        document.title = data.appName ? data.appName : "WESS Consumer Web App";
      });
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  errorCaptured() {
    // Capture unhandled error
    this.$router.push("/error");
  },
};
</script>

<style lang="scss">
@import "~bootstrap/dist/css/bootstrap.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $normal-font-color;
  max-width: 512px;
  margin: auto;
  border: 1px solid #ccc;
  min-height: 100vh;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.Vue-Toastification__toast {
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

// Scroll Bar Style
/* width */
::-webkit-scrollbar {
  width: 15px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #d3d3d3;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a9a9a9;
  transform: scale(1.5, 1.5);
  transition: 0.3s;
  cursor: pointer;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:active {
  background: #808080;
  transform: scale(1.5, 1.5);
  transition: 0.3s;
  cursor: pointer;
}

/* Hide scrollbar for Chrome, Safari and Opera */
@media (max-width: 512px) {
  ::-webkit-scrollbar {
    display: none;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}

.style-offline-message {
  position: absolute;
  top: 0;
  height: 50px;
  background-color: $error-color;
  color: white;
  width: 100%;
  max-width: 510px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  transition: 0.5s;
  z-index: 9999;
}
</style>
